module.exports = __webpack_public_path__ + "static/media/participantes.e9ace2e2.png";